import { useState, useEffect, useRef } from 'react'
import req from '@sportninja/common/api/request'
import { OrganizationTreeNode } from 'src/context/MyScheduleContext/types'

export type { OrganizationTreeNode }

interface UseOrganizationsTreeReturn {
  data: OrganizationTreeNode[] | null
  isLoading: boolean
  error: Error | null
}

/**
 * Hook to fetch the user's organizations tree hierarchy
 * Uses req directly with a ref flag to prevent duplicate API calls
 */
export function useOrganizationsTree(): UseOrganizationsTreeReturn {
  const [data, setData] = useState<OrganizationTreeNode[] | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)
  const fetchedRef = useRef(false)

  useEffect(() => {
    if (fetchedRef.current) {
      return
    }
    fetchedRef.current = true

    const fetchTree = async () => {
      try {
        const response = await req(
          '/users/me2/organizations/tree?include_schedules=true'
        )
        setData(response.data)
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }
    fetchTree()
  }, [])

  return { data, isLoading, error }
}

export default useOrganizationsTree
